import script from "./AbilityRow.vue?vue&type=script&setup=true&lang=js"
export * from "./AbilityRow.vue?vue&type=script&setup=true&lang=js"

import "./AbilityRow.vue?vue&type=style&index=0&id=a78dccfc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a78dccfc"]])

export default __exports__